export function projectTableConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu:false,
    refreshBtn:false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    indexLabelWidth: 35,
    selection:true,
    selectionWidth:45,
    searchShow: false,
    border:true,
    column: [
      {
        label: '项目名称',
        searchPlaceholder: "请输入项目名称",
        placeholder: '请输入项目名称',
        prop: "name",
        slot: true,
        search: true,
        // overHidden: true,
        width: '230'
      },{
        label: '项目编号',
        prop: "number",
        // overHidden: true,
        width: "85",        
      },
      {
        label: '保理类型',
        prop: "projectTypeStr",
        width	: '170'
      },{
        label: '卖方',
        prop: "sellerCustName",
        search: true,
        searchslot: true,
        searchPlaceholder: "请输入客户名称",
        // overHidden: true,
        width	: '200'
      },{
        label: '买方',
        prop: "buyerCustName",
        // overHidden: true,
        width	: '150'      
      },{
        label: '保理额度(元)',
        prop: "factoringCredit",
        width: "105",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: '业务主办',
        width: "60",
        prop: "managerUserName",
        // overHidden: true,
      },{
        label: '业务协办',
        width: "60",
        prop: "assistUserName",
        // overHidden: true,
      },{
        label: '所属部门',
        width: "100",
        prop: "managerDeptName",
        // overHidden: true,
      },
      {
        label: '创建时间',
        width: "120",
        prop: "createTime",
        // overHidden: true,
      }
    ]
  }
}

export function projectAddConfig(selectPersonClick) {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: "项目名称",
        prop: "name",
        disabled: false,
        placeholder: "请输入项目名称",
        rules: [{
          required: true,
          message: "请输入项目名称",
          trigger: "change"
        }]
      },{
        label: "保理类型",
        prop: "projectType",
        type: "select",
        disabled: false,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请选择保理类型",
          trigger: "change"
        }]
      },{
        // 选择类型
        label: "卖方(债权人)",
        prop: "sellerCustId",
        disabled: false,
        dicUrl: '/api/blade-/zd/custom/dict',
        dicMethod:'post',
        dicQuery:{
          custType: 2
        },
        formslot: true,
        rules: [{
          required: true,
          message: "请选择卖方",
          trigger: "change"
        }]
      },{
        label: "买方(债务人)",
        prop: 'buyerCustName',
        disabled: false,
        rules: [{
          required: true,
          message: "请选择买方",
          trigger: "change"
        }]
      },{
        label: "项目来源",
        prop: "projectComeFrom",
        type: "select",
        disabled: false,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_source',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请选择项目来源",
          trigger: "change"
        }]        
      },{
        label: "保理额度",
        prop: 'factoringCredit',
        disabled: false,
        append: '元',
        rules: [{
          required: true,
          message: "请输入保理额度",
          trigger: "blur"
        }]      
      },{
        label: '业务主办',
        prop: 'managerUserName',
        disabled: true
      },{
        label: '业务协办',
        prop: 'assistUserName',
        click: () => {
          selectPersonClick();
        }
      },{
        label: '项目说明',
        prop: 'projectTranslation',
        display: true,
        formslot: true,
        span: 24,
        rules: [{
          required: true,
          message: "请输入项目说明",
          trigger: "blur"
        }]        
      }
    ]
  }
}

export function projectDetailConfig(selectPersonClick) {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        // 选择类型
        label: "卖方(债权人)",
        prop: "sellerCustId",
        disabled: false,
        dicUrl: '/api/blade-/zd/custom/dict',
        dicMethod:'post',
        dicQuery:{
          custType: 2
        },
        formslot: true,
        rules: [{
          required: true,
          message: "请选择卖方",
          trigger: "change"
        }]
      },{
        label: "买方(债务人)",
        prop: 'buyerCustName',
        disabled: false,
        rules: [{
          required: true,
          message: "请选择买方",
          trigger: "change"
        }]
      },{
        label: "项目名称",
        prop: "name",
        disabled: true,
        placeholder: "等待生成项目名称"
      },{
        label: '项目编号',
        disabled: true,
        prop: 'number'
      },{
        label: "保理类型",
        prop: "projectType",
        type: "select",
        disabled: false,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请选择保理类型",
          trigger: "change"
        }]        
      },{
        label: "项目来源",
        prop: "projectComeFrom",
        type: "select",
        disabled: false,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_source',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        rules: [{
          required: true,
          message: "请选择项目来源",
          trigger: "change"
        }]        
      },{
        label: '保理额度（元）',
        prop: "factoringCredit",
        disabled: false,
        append: '元',
        rules: [{
          required: true,
          message: "请输入保理额度",
          trigger: "blur"
        }]        
      },{
        label: '所属部门',
        prop: 'managerDeptName',
        disabled: true
      },{
        label: '业务经理',
        prop: 'managerUserName',
        disabled: true
      },{
        label: '业务协办',
        prop: 'assistUserName',
        click: () => {
          selectPersonClick();
        }
      },{
        label: '实际尽调额度',
        prop: 'realReportCredit',
        disabled: true,
      }
    ]    
  }
}

export function projectDetailTableConfig() {
  return {
    refreshBtn:false,
    menu:false,
    addBtn: false,
    showLoading:false,
    showCard:false,
    showBorder: false,
    showStripe: false,
    showHeader: true,
    showIndex: true,
    showCheckbox: false,
    columnBtn: false,
    searchBtn: true,
    submitBtn: false,
    emptyBtn: false,
    align: 'center',
    border:true,
    column: [
      {
        label: '拜访编号',
        prop: 'visitNo'
      },
      {
        label: '拜访名称',
        prop: 'visitName',
        formslot: true,
        width: '260',
        overHidden: true
      },
      {
        label: '拜访人员',
        prop: 'visitPeopleNames',
        overHidden: true
      },
      {
        label: '拜访时间',
        prop: 'visitTime',
        overHidden: true
      },
      {
        label: '拜访类型',
        prop: 'visitTypeStr',
        overHidden: true
      },
      {
        label: '客户名称',
        prop: 'custName',
        width: '150',
        overHidden: true
      }
    ]
  }
}

export function repaymentListConfig(getMoney) {
  return {
    refreshBtn:false,
    menu:false,
    addBtn: false,
    showLoading:false,
    showCard:false,
    showBorder: false,
    showStripe: false,
    showHeader: true,
    showIndex: true,
    showCheckbox: false,
    columnBtn: false,
    searchBtn: true,
    submitBtn: false,
    emptyBtn: false,
    align: 'center',
    index: true,
    indexLabel: "序号",    
    border:true,
    column: [
      {
        label: '合同名称',
        prop: 'contractName',
        width: 150,
        // overHidden: true,
        slot: true
      },
      {
        label: '合同金额（元）',
        prop: 'factoringCredit',
        formatter: (row, value, label, column)=> {
          return `${getMoney(Number(value))}元`
        }
      },
      {
        label: '内部收益率（%）',
        prop: 'xirr',
        formatter: (row, value, label, column)=> {
          return `${(Number(value)*100).toFixed(4)}%`
        }        
      },
      {
        label: '报价方案个数',
        prop: 'rentNumber'
      },
      {
        label: '合同状态',
        prop: 'auditStatusStr'
      },
      {
        label: '创建日期',
        prop: 'createTime'
      }
    ]
  }
}

export function stepsConfig() {
  return {
    stepsConfig: {
      active: 0,
      space: '33%',
      // auditLog: this.originData['auditLog']?JSON.parse(this.originData['auditLog']):''
    },
    stepArray: [{
      title: '项目立项',
      description: '',
      indexProp: 'lx',
      slot: true,
    },{
      title: '项目尽调',
      indexProp: 'jd',
      description: '',
    },{
      title: '合同阶段',
      indexProp: 'ht',
      description: ''
    },{
      title: '资金投放',
      indexProp: 'tf',
      description: ''
    },{
      title: '资金回收',
      indexProp: 'hs',
      description: ''
    },{
      title: '项目收尾',
      indexProp: 'sw',
      description: '',
      lastOne: true
    },{
      title: '项目调整',
      indexProp: 'tz',
      lastActive: false,
      description: ''
    }]
  }
}

export function highchartsConfig() {
  return {
    chart: {
        type: 'pie',
        options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
        }
    },
    title: {
        text: '项目额度一览'
    },
    tooltip: {
        pointFormat: '{series.name}占比: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
                enabled: true,
                format: '{point.name}'
            }
        }
    },
    series: [{
        type: 'pie',
        name: '金额',
        data: [
            {
              name: '已用金额',
              y: ''
            },
            {
                name: '项目三',
                y: ''
            }
        ]
    }]
  }
}

export function paymentConfig(getMoney) {
  return [
      {
          label: '放款金额',
          prop: 'quotationPrice',
          span: '8',
          formatter: (label, value)=> {
            return `${getMoney(Number(value))}元`
          }
      },
      {
          label: '期数',
          prop: 'leaseTerm',
          slot:true,
          span: '8',
          unit: '期'
      },
      {
          label: '已还期数',
          prop: 'issueCovered',
          span: '8',
          formatter: (row, value, label, column) => {
            return `${value}期`;
          }
      },
      {
          label: '回收成本总额',
          prop: 'totalPrincipalCovered',
          span: '8',
          unit: '元',
          formatter: (label, value)=> {
            return `${getMoney(Number(value))}元`
          }
      },
      {
          label: '未回收成本',
          prop: 'totalPrincipalUncovered',
          span: '8',
          unit: '元',
          formatter: (label, value)=> {
            return `${getMoney(Number(value))}元`
          }
      },
      {
          label: '利息收入总额',
          prop: 'totalInterest',
          span: '8',
          unit: '元',
          formatter: (label, value)=> {
            return `${getMoney(Number(value))}元`
          }
      },
      {
        label: '已收利息收入',
        prop: 'totalInterestCovered',
        span: '8',
        unit: '元',
        formatter: (label, value)=> {
          return `${getMoney(Number(value))}元`
        }
      },      
      {
          label: '未收利息收入',
          prop: 'totalInterestUncovered',
          span: '8',
          unit: '元',
          formatter: (label, value)=> {
            return `${getMoney(Number(value))}元`
          }
      }
  ]
}